import constant from '../../store/constant'
import config from '../../store/config'
var utils = require('../../utils')
export default {
  name: 'shop-edit',
  created () {
    this.shopId = this.$route.params.shopId
    this.search()
  },
  data () {
    return {
      shopId: null,
      isDisplay: false,
      kinyuNitiji: false,
      hensyuNitiji: false,
      shop: {
        shop_name: null,
        shop_name_furigana: null,
        post_no: null,
        address1: null,
        address2: null,
        tel: null,
        fax: null,
        map_lat: null,
        map_lng: null,
        map_zoom: null,
        fax_header: null,
        report_date_flag: null,
        report_message: null
      }
    }
  },
  mounted () {
    // ヘルプボタン表示
    utils.helpModalShow()
  },
  computed: {
    loading() {
      return this.$store.getters.apiLoading
    },
    notify () {
      return this.$store.getters.shopsNotify
    }
  },
  methods: {
    search: function () {
      this.$store.dispatch('SHOP_GET', {data: {shop_id: this.shopId}})
      .then(
        (res) => {
          this.callbackGetShopData(res)
        },
        () => {}
      )
    },
    callbackGetShopData: function (res) {

      var shop = res.data
      this.shop.shop_name = shop.attributes['shop-name']
      this.shop.shop_name_furigana = shop.attributes['shop-name-furigana']
      this.shop.post_no = shop.attributes['post-no']
      this.shop.address1 = shop.attributes['address1']
      this.shop.address2 = shop.attributes['address2']
      this.shop.tel = shop.attributes['tel']
      this.shop.fax = shop.attributes['fax']
      this.shop.map_lat = shop.attributes['map-lat']
      this.shop.map_lng = shop.attributes['map-lng']
      this.shop.map_zoom = shop.attributes['map-zoom']
      this.shop.fax_header = shop.attributes['fax-header']
      this.shop.report_date_flag = shop.attributes['report-date-flag']
      this.shop.report_message = shop.attributes['report-message']

      if(this.shop.report_date_flag == 3){
        this.kinyuNitiji = true
        this.hensyuNitiji = true
      }
      if(this.shop.report_date_flag == 1){
        this.kinyuNitiji = true
      }
      if(this.shop.report_date_flag == 2){
        this.hensyuNitiji = true
      }

      // GoogleMaps 更新
      utils.googleMapEvent({
        js:          constant.js.google_maps,
        key:         config.google_map_api_key,
        mapElmId:    'map',
        lat:         this.shop.map_lat,
        lng:         this.shop.map_lng,
        zoom:        this.shop.map_zoom,
        mapCallback: this.mapCallback,
        map_default: constant.map_default,
      })

      this.isDisplay = true
    },
    /** GoogleMaps */
    /** クリック時コールバック */
    mapCallback: function(lat, lng, zoom) {
      this.shop.map_lat = lat
      this.shop.map_lng = lng
      this.shop.map_zoom = zoom
    },
    chageReportFlg: function() {
      if(this.kinyuNitiji && this.hensyuNitiji){
        this.shop.report_date_flag = 3
      }
      if(this.kinyuNitiji && this.hensyuNitiji == false){
        this.shop.report_date_flag = 1
      }
      if(this.kinyuNitiji == false && this.hensyuNitiji){
        this.shop.report_date_flag = 2
      }
      if(this.kinyuNitiji == false && this.hensyuNitiji == false){
        this.shop.report_date_flag = null
      }
    },
    onSave: function() {
      this.$store.dispatch('SHOP_UPDATE', { data: { shop_id: this.shopId, shop: this.shop }, callback: this.onSaved })
    },
    onSaved: function() {
      this.$router.push({ path: '/edit_shops', query: { type: this.$router.currentRoute.query.type } })
    },
    onClickCancel: function() {
      this.$router.push({ path: '/edit_shops', query: { type: this.$router.currentRoute.query.type } })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shop-edit.js